var Autocomplete = function(options) {
      this.form_selector = options.form_selector
      this.url = options.url || '/search/autocomplete/'
      this.delay = parseInt(options.delay || 300)
      this.minimum_length = parseInt(options.minimum_length || 3)
      this.form_elem = null
      this.query_box = null
    }

    Autocomplete.prototype.setup = function() {
      var self = this

      this.form_elem = $(this.form_selector)
      this.query_box = this.form_elem.find('input[name=q]')
      this.close_btn = $('.tip-container')

      // Watch the input box.
      this.query_box.on('keyup', function(event) {
        var query = self.query_box.val();

        if(query.length < self.minimum_length) {
          return false;
        }
        if (event.key == 'Enter'){

        }
          else{
            self.fetch(query)
        }
        ;
      })

    }

    Autocomplete.prototype.fetch = function(query) {
      var self = this

      this.query_text = query

      $.ajax({
        url: this.url
      , data: {
          'q': query
        }
      , success: function(data) {
          self.show_results(data, query)
        }
      })
    }

    window.clearSearch = function () {
      $('.tip-container').remove()
      $('.search').removeClass('expand')
      $('input[name=q]').val("")
      return false
    }

    Autocomplete.prototype.show_results = function(data, query="") {
      // Remove any existing results.
      $('.tip-container').remove()

      var results = data.results || []
      var results_wrapper = $('<div class="tip-container"><button type="button" class="close" onclick="clearSearch()"><span>&times;</span></button></div>')
      var base_elem = $('<div class="tip-item"><a href="#" class="ac-result"></a></div>')

      if(results.length > 0) {
        for(var res_offset in results) {
          var elem = base_elem.clone()
          // Don't use .html(...) here, as you open yourself to XSS.
          // Really, you should use some form of templating.
          elem.find('.ac-result').text(results[res_offset].title)
          elem.find('.ac-result').attr('href', results[res_offset].link)
          results_wrapper.append(elem)
        }
      }
      else {
        var elem = base_elem.clone()
        elem.text("Ничего не найдено")
        results_wrapper.append(elem)
      }

      results_wrapper.append(`<div><a href="/search/?q=${query}" class="all-results-link">Показать все результаты</a></div>`)

      this.query_box.after(results_wrapper)
    }

jQuery(document).ready(function() {
      window.autocomplete = new Autocomplete({
        form_selector: '.autocomplete-me'
      })
      window.autocomplete.setup()
})